/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Hold_DraftInputs */

const en_wb_hold_draft = /** @type {(inputs: Wb_Hold_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep as a draft`)
};

const lv_wb_hold_draft = /** @type {(inputs: Wb_Hold_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atstāt kā melnrakstu`)
};

/**
* | output |
* | --- |
* | "Keep as a draft" |
*
* @param {Wb_Hold_DraftInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_hold_draft = /** @type {((inputs?: Wb_Hold_DraftInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Hold_DraftInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_hold_draft(inputs)
	return en_wb_hold_draft(inputs)
});